export default __webpack_public_path__ + "static/media/cannadaClassical.c1ae3405.png";